import styled from 'styled-components';
import Modal from '../../Modal';
import Button from '../../Button';

export const StyledPopup = styled(Modal)`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;

export const StyledButton = styled(Button)`
  border-radius: 21px;
  border: none;
  color: #007aff;
  cursor: pointer;
  font-size: 14px;
  background: transparent;
  height: 25px;
  line-height: 24px;
  min-height: 25px;
  min-width: 25px;
  outline: 0;
  overflow: visible;
  padding: 0;
  position: relative;
  text-align: center;

  ${p =>
    p.isAction &&
    `
    padding: 0 5px;
  `}

  svg {
    z-index: 2;
    display: block;
    margin: 0 auto;
    position: relative;
  }

  * {
    outline: none;
  }

  span {
    display: block;
    margin-bottom: -7px;
  }
`;

export const StyledTextButton = styled.button`
  border: none;
  outline: none;
  background: none;
  margin-left: 10px;
  color: #007aff;
  cursor: pointer;
  font-family: 'Backpack', sans-serif;
  font-size: 14px;
`;
